import React from 'react';
import useCommonRoomListState from './CommonRoomList.state';
import CommonRoomListView from './CommonRoomList.view';

const CommonRoomList: React.FC<{}> = () => {
    const state = useCommonRoomListState();
    return <CommonRoomListView {...state} />;
};
export default CommonRoomList;
